import { useCurrentPermissionsStore } from '@onereach/permissions-ui';
import { useRouter } from 'vue-router';

export const useCheckPermission = () => {
  const store = useCurrentPermissionsStore();
  const router = useRouter();

  const can = (permission: string) => {
    if (!permission) return true;
    return !!store.hasPermission(permission);
  };

  const routeCache = new Map<string, ReturnType<typeof router.resolve>>();

  const canAccessRoute = (to: string) => {
    let route = routeCache.get(to);
    if (!route) {
      route = router.resolve(to);
      routeCache.set(to, route);
    }

    if (route.meta?.permission) {
      return !!store.hasPermission(route.meta.permission as string);
    }
    return true;
  };

  return {
    can,
    canAccessRoute,
  };
};
